
/**
 * Hulpmiddelen voor cache-busting en versiecontrole
 */

// Genereer een versie-timestamp voor de huidige sessie
// Gebruiken we voor cache-busting op assets
export const APP_VERSION = Date.now().toString();

// Interval in milliseconden voor het controleren op een nieuwe versie (1 minuut)
export const VERSION_CHECK_INTERVAL = 60 * 1000;

// Genereer een URL met cache-busting parameter
export const addCacheBuster = (url: string): string => {
  // Controleer of de URL al een querystring heeft
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${APP_VERSION}`;
};

// Ververs de pagina als er een nieuwere versie is
export const setupVersionChecker = (): void => {
  // Bewaar de oorspronkelijke versie die geladen werd
  const initialVersion = APP_VERSION;
  
  // Controleer periodiek of er een nieuwe versie beschikbaar is
  setInterval(() => {
    // Maak een fetch-request naar een kleine bestand met cache-busting om te forceren dat het altijd vers is
    fetch(`/version-check.txt?v=${Date.now()}`)
      .then(response => {
        // Als de server status niet OK is (bijv. 304 Not Modified), negeren we het
        if (!response.ok) return;
        
        // Controleer de 'x-app-version' header (die we zullen toevoegen in de Vite config)
        const serverVersion = response.headers.get('x-app-version');
        
        // Als er een nieuwere versie beschikbaar is, ververs de pagina
        if (serverVersion && serverVersion !== initialVersion) {
          console.log(`Nieuwe versie gedetecteerd (${serverVersion} vs ${initialVersion}). Pagina wordt ververst...`);
          window.location.reload();
        }
      })
      .catch(error => {
        console.warn('Versiecontrole mislukt:', error);
      });
  }, VERSION_CHECK_INTERVAL);
};
